import React, { Component, ErrorInfo, ReactNode } from 'react';
import { logger } from './logglyLogger';
import { sourceTagsFromComponentName } from './sourceTags';

interface ErrorBoundaryProps {
  name: string;
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const tags = sourceTagsFromComponentName(this.props.name);
    logger.error(`React render error in ${this.props.name}`, error, {
      sourceFile: tags.SourceFile,
      sourceClass: tags.SourceClass,
      sourceLayer: tags.SourceLayer,
      componentStack: errorInfo.componentStack,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page. If the problem continues, contact support.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
